import React, { PureComponent } from 'react';
import styles from './Divider.module.css';

export default class Divider extends PureComponent {
  render() {
    const props = this.props;
    return <hr className={styles.hr} {...props} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Divider/index.js